(function($)
{

    $.fn.msxiformsubmit = function(options)
    {
        // build main options before element iteration
        var opts = $.extend({}, $.fn.msxiformsubmit.defaults, options);

        return this.each(function()
                         {
                             var $this = $(this);
                             // build element specific options
                             var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
                             eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

                             // Enable any disabled form buttons incase the user got to the page using the back button
                             // This assumes that we never have form buttons initially disabled on the page.
                             // If a button is initially disabled then class 'button-initial-disabled' should be added to it.
                             $this.find('input[type="submit"], button[type="submit"]').filter('[disabled]').not('.button-initial-disabled').button('enable');

                             // Store the clicked button
                             $this.find('input[type="submit"], button[type="submit"]').click(function(){
                                 $this.data('last-submit-button', $(this));
                             });

                             var webcal = $this.attr('action').indexOf('webcal://') > -1;
                             if (!webcal) {
                                 $this.one('submit', submit);
                             } else {
                                 $this.on('submit', submit);
                             }

                             function submit(){
                                 if (!webcal) {
                                     // Prevent any more submissions
                                     var duplicateSubmissionBlocker = function () {
                                         return false;
                                     };
                                     // assign to data variable so that other scripts can access if they wish to remove
                                     $this.data('duplicateSubmissionBlocker', duplicateSubmissionBlocker);
                                     $this.submit(duplicateSubmissionBlocker);
                                 }

                                 // Create a hidden field to ensure button value is submitted
                                 var button = $this.data('last-submit-button');
                                 if(button && button.attr('name'))
                                 {
                                     $this.append($('<input type="hidden" />').attr('name', button.attr('name')).val(button.val()));
                                     $this.removeData('last-submit-button');
                                 }

                                 // Prevent duplicate submissions
                                 $(':input', $this).prop('readonly', true);
                                 // ':submit' blows up in IE8. Not sure why but a more specific selector works fine.
                                 if (!webcal) {
                                     try {
                                         $this.find('input.ui-button[type="submit"], button.ui-button[type="submit"]').button('disable');
                                     } catch (e) {
                                         // Using try block because for unknown reason this sometimes fails with:
                                         // "Uncaught Error: cannot call methods on button prior to initialization; attempted to call method 'disable'"
                                     }
                                 }
                             }
                         });
    };
    //
    // plugin defaults
    //
    $.fn.msxiformsubmit.defaults = {};

})(jQuery);